import { Fragment } from "react";
import Proptypes from "prop-types";
import classnames from "classnames";
import { UncontrolledTooltip } from "reactstrap";
import Avatar from "../Avatar/Avatar";

const AvatarGroup = (props) => {
  const { data, size, placement, className } = props;

  const renderData = () => {
    return data.map((item, index) => {
      // Buat ID yang aman dengan mengganti semua karakter non-alphanumeric dengan underscore
      const safeId =
        item.id ||
        (item.title
          ? `avatar_${index}_${item.title.replace(/[^a-zA-Z0-9]/g, "_")}`
          : `avatar_${index}`);
      return (
        <Fragment key={index}>
          {item.title ? (
            <UncontrolledTooltip placement={placement} target={safeId}>
              {item.title}
            </UncontrolledTooltip>
          ) : null}
          <Avatar
            className={classnames("zoom-in", {
              [item.className]: item.className,
            })}
            size={size}
            id={safeId}
            {...item}
          />
        </Fragment>
      );
    });
  };

  return (
    <div
      className={classnames("avatar-group", {
        [className]: className,
      })}
    >
      {renderData()}
    </div>
  );
};

AvatarGroup.propTypes = {
  data: Proptypes.array.isRequired,
};

export default AvatarGroup;
